/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Fieldset } from "~/components/Forms";
import { NamedLinkItem } from "../BasicInfoComponents/NamedLinkItem";
import { Link } from "../types";

type EditLinksProps = {
  links: Link[];
  setLinks: React.Dispatch<React.SetStateAction<Link[]>>;
};

function EditLinks({ links, setLinks }: EditLinksProps) {
  const updateLink = (updatedLink: Link) => {
    setLinks((prevState) =>
      prevState.map((prevItem) =>
        prevItem.id === updatedLink.id ? updatedLink : prevItem
      )
    );
  };

  const deleteLink = (id: string) => {
    setLinks((prevState) => prevState.filter((link) => link.id !== id));
  };

  return (
    <>
      {links.map((link: Link) => (
        <Fieldset key={link.id}>
          <div>
            <NamedLinkItem
              link={link}
              updateLink={updateLink}
              deleteLink={deleteLink}
            />
          </div>
        </Fieldset>
      ))}
    </>
  );
}

export { EditLinks };
